const locale = require('./copySubmissionModal.i18n.json');

/*@ngInject*/
const CopySubmissionModalController = function ($rootScope, $scope, coreConstant, submissionCopyOptions) {

    $scope.i18n = locale;

    $scope.viewModel = {
        title: _.get($scope.i18n, 'title'),
        cancelButton: _.get($scope.i18n, 'cancel'),
        okButton: _.get($scope.i18n, 'confirm'),
        fullSubmissionCopyOptions: [submissionCopyOptions.ALL],
        applicationOnlyCopyOptions: [submissionCopyOptions.SUBMISSION_APPLICATION_FORMS]
    };

    $scope.viewModel.copyOptions = $scope.viewModel.fullSubmissionCopyOptions;

    $scope.onClickFullSubmissionLabel = function () {
        $scope.viewModel.copyOptions = $scope.viewModel.fullSubmissionCopyOptions;
    };

    $scope.onClickApplicationOnlyLabel = function () {
        $scope.viewModel.copyOptions = $scope.viewModel.applicationOnlyCopyOptions;
    };

    $scope.onConfirm = function () {
        $scope.$close({
            copyOptions: $scope.viewModel.copyOptions
        });
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('copySubmissionModalController', CopySubmissionModalController);
